import { render, staticRenderFns } from "./ExtraDefault.vue?vue&type=template&id=01731fb6&"
import script from "./ExtraDefault.vue?vue&type=script&lang=js&"
export * from "./ExtraDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports